import React from 'react';
import { IconCardFilled, IconDocFillFilled, IconLayersFilled, IconPieChartFilled, IconSettingsFilled, IconUserFilled } from '@carnica/graphics';
export var CardIcon = function CardIcon(_ref) {
  var cardType = _ref.cardType;
  switch (cardType) {
    case 'profile':
      return /*#__PURE__*/React.createElement(IconUserFilled, {
        color: "primary",
        "data-t-id": "components-CardIcon"
      });
    case 'myData':
      return /*#__PURE__*/React.createElement(IconDocFillFilled, {
        color: "primary"
      });
    case 'detalization':
      return /*#__PURE__*/React.createElement(IconPieChartFilled, {
        color: "primary"
      });
    case 'payment':
      return /*#__PURE__*/React.createElement(IconCardFilled, {
        color: "primary"
      });
    case 'services':
      return /*#__PURE__*/React.createElement(IconLayersFilled, {
        color: "primary"
      });
    case 'settings':
      return /*#__PURE__*/React.createElement(IconSettingsFilled, {
        color: "primary"
      });
    default:
      return null;
  }
};